module.exports = __webpack_public_path__ + "static/media/IMG-5.a6b5b8a3.jpg";